/**
 * tourSteps/projectFilesSteps.js
 * Comprehensive tour steps for Project Files & Centralized Asset Management.
 * Explicitly covers Client Work vs Internal (In-House) Work, 5-folder architecture,
 * AI organization, search, display modes, and asset previews.
 */

export const projectFilesSteps = [
    {
        title: 'Project Files Explorer',
        description: 'Centralized production file and digital asset management. All project documents, design assets, and client deliverables are stored securely and organized hierarchically.',
        selector: '[data-tour="files-explorer-header"]',
        placement: 'bottomLeft',
    },
    {
        title: 'Client Work vs Internal Work',
        description: 'Easily separate external client initiatives from in-house internal brand operations. Switch between Client Work and Internal Work with one click to keep company assets distinct from client projects.',
        selector: '[data-tour="files-work-type-toggle"]',
        fallbackSelector: '[data-tour="files-sidebar-tree"]',
        placement: 'right',
    },
    {
        title: 'Client Work Directory',
        description: 'Contains all client-facing files: master service agreements, technical specifications, creative briefs, revision feedback, and final deliverables published to the CRE client portal.',
        selector: '[data-tour="files-client-work-tab"]',
        fallbackSelector: '[data-tour="files-work-type-toggle"]',
        placement: 'bottom',
    },
    {
        title: 'Internal (In-House) Work Directory',
        description: 'Dedicated space for in-house company brands, operational templates, design system tokens, internal pitch decks, and internal meeting documentation.',
        selector: '[data-tour="files-internal-work-tab"]',
        fallbackSelector: '[data-tour="files-work-type-toggle"]',
        placement: 'bottom',
    },
    {
        title: 'Structured 5-Folder Architecture',
        description: 'Every project is automatically provisioned with a standardized 5-folder directory: 01 Requirements, 02 Resources, 03 Revisions, 04 Meeting Notes, and 05 Deliverables.',
        selector: '[data-tour="files-sidebar-tree"]',
        placement: 'right',
    },
    {
        title: 'Folder Tree Filter',
        description: 'Quickly filter the folder hierarchy by project code or brand name to jump straight to the exact asset directory you need.',
        selector: '[data-tour="files-tree-search"]',
        fallbackSelector: '[data-tour="files-sidebar-tree"]',
        placement: 'bottom',
    },
    {
        title: 'Upload & AI File Organization',
        description: 'Upload files directly into target folders. The intelligent auto-classifier analyzes file contents to suggest proper folder placement, revision versioning, and standardized file names.',
        selector: '[data-tour="files-upload-btn"]',
        placement: 'bottom',
    },
    {
        title: 'Global Asset Search',
        description: 'Search across all projects, brands, and file types by name, extension, uploader, or metadata tags.',
        selector: '[data-tour="files-search-btn"]',
        placement: 'bottom',
    },
    {
        title: 'Grid & List Display Modes',
        description: 'Toggle between visual card preview grid with high-resolution thumbnails and a compact tabular list view for bulk operations.',
        selector: '[data-tour="files-viewmode-toggle"]',
        placement: 'bottom',
    },
    {
        title: 'Active & Archived File Filters',
        description: 'Toggle between active production assets and historical archived files to keep project directories clean without losing revision history.',
        selector: '[data-tour="files-status-filter"]',
        placement: 'bottomRight',
    },
    {
        title: 'Interactive Asset Cards & Preview',
        description: 'Click any file to preview, download from Cloudflare R2, inspect version history, or publish verified deliverables directly to the CRE client portal.',
        selector: '[data-tour="files-grid-list"]',
        placement: 'top',
    },
];
